import {Mapper} from '@s-ui/domain'

export class SeoAdsListSemanticFinancedMetaConfigMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.log
   * */

  _getAdsListSemanticConfigKey = ({entry}) => {
    const hasEntry = entry !== 0

    const isDefault = hasEntry
    const isWithoutEntry = !hasEntry

    switch (true) {
      case isDefault:
        return 'default'
      case isWithoutEntry:
        return 'withoutEntry'
      default:
        return 'default'
    }
  }

  map = ({adsListSemanticConfig, params: {entry}}) => {
    const adsListSemanticConfigKey = this._getAdsListSemanticConfigKey({
      entry
    })

    return adsListSemanticConfig[adsListSemanticConfigKey] || adsListSemanticConfig.default
  }
}
